import { Box, TextField, Select, Chip, TableContainer, Table, TableCell, TableRow, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PageContainer = styled(Box)(({ theme }) => ({
	padding: theme.spacing(4),
	backgroundColor: theme.palette.background.default,
	minHeight: 'calc(100vh - 120px)',
}));

export const FiltersContainer = styled(Box)(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: '2fr 1fr 1fr 1fr',
	gap: theme.spacing(2),
	marginBottom: theme.spacing(3),
	padding: theme.spacing(3),
	backgroundColor: theme.palette.background.paper,
	borderRadius: theme.shape.borderRadius,
	boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
	[theme.breakpoints.down('lg')]: {
		gridTemplateColumns: '1fr 1fr 1fr',
	},
	[theme.breakpoints.down('md')]: {
		gridTemplateColumns: '1fr 1fr',
	},
	[theme.breakpoints.down('sm')]: {
		gridTemplateColumns: '1fr',
	},
}));

export const SearchField = styled(TextField)(({ theme }) => ({
	'& .MuiOutlinedInput-root': {
		backgroundColor: theme.palette.background.default,
	},
}));

export const FilterSelect = styled(Select)(({ theme }) => ({
	backgroundColor: theme.palette.background.default,
	[theme.breakpoints.down('md')]: {
		minWidth: '100%',
	},
}));

export const AppliedFiltersContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexWrap: 'wrap',
	gap: theme.spacing(1),
	alignItems: 'center',
	marginBottom: theme.spacing(3),
}));

export const FilterChip = styled(Chip)(({ theme }) => ({
	backgroundColor: theme.palette.primary.main,
	color: theme.palette.primary.contrastText,
	fontWeight: 500,
	'& .MuiChip-deleteIcon': {
		color: theme.palette.primary.contrastText,
	},
}));

export const ClearFiltersButton = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(0.5),
	cursor: 'pointer',
	color: theme.palette.text.secondary,
	fontSize: '0.875rem',
	marginLeft: 'auto',
	'&:hover': {
		color: theme.palette.primary.main,
	},
}));

export const ResultsHeader = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	marginBottom: theme.spacing(3),
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
	backgroundColor: theme.palette.background.paper,
	borderRadius: theme.shape.borderRadius,
	boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
}));

export const StyledTable = styled(Table)(() => ({
	minWidth: 700,
}));

export const StyledTableHeaderCell = styled(TableCell)(({ theme }) => ({
	padding: theme.spacing(1.5, 2),
	fontWeight: 600,
	backgroundColor: theme.palette.grey[50],
	borderBottom: `2px solid ${theme.palette.divider}`,
	color: theme.palette.text.secondary,
	fontSize: '0.8rem',
	textTransform: 'uppercase',
	letterSpacing: '0.05em',
	whiteSpace: 'nowrap',
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
	padding: theme.spacing(1.75, 2),
	borderBottom: `1px solid ${theme.palette.divider}`,
	verticalAlign: 'middle',
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:hover': {
		backgroundColor: theme.palette.action.hover,
	},
	'&:last-child td': {
		borderBottom: 0,
	},
}));

export const UserCell = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(1.5),
}));

export const UserAvatar = styled(Avatar)(({ theme }) => ({
	width: 30,
	height: 30,
	fontSize: '0.75rem',
	backgroundColor: theme.palette.primary.main,
}));

export const Pager = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'flex-end',
	marginTop: theme.spacing(3),
}));

export const EmptyStateContainer = styled(Box)(({ theme }) => ({
	textAlign: 'center',
	marginTop: theme.spacing(8),
	padding: theme.spacing(4),
}));
